module.exports = __webpack_public_path__ + "static/img/icomoon.f558046.svg";


//////////////////
// WEBPACK FOOTER
// ./src/vendor/wangEditorV2/fonts/icomoon.svg?-qdfu1s
// module id = 3556
// module chunks = 6